import { render, staticRenderFns } from "./ClaimTriple.vue?vue&type=template&id=0498a666&"
import script from "./ClaimTriple.vue?vue&type=script&lang=ts&"
export * from "./ClaimTriple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports